import { useState, useEffect } from "react";
import { useGetStudioQuery } from "../../features/api/apiSlice";

function useStudioConnection() {
  const { data: studio } = useGetStudioQuery();
  const { REACT_APP_API_ENDPOINT } = process.env;
  const url = new URL(REACT_APP_API_ENDPOINT!);
  const domain = url.hostname;

  const [token, setToken] = useState("");
  const serverUrl = `wss://${domain}/webrtc`;
  const connectionsParams = {token, serverUrl};

  useEffect(() => {
      if (!studio) return;

      setToken(studio.token);
  }, [studio]);

  return {
    token,
    serverUrl,
    connectionsParams
  };
}

export default useStudioConnection;